import React, { FC } from 'react';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../BaseTemplate';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';
import { LandscapeProjectsAddRequestedSupportOrganism } from '../../organisms';
import LandscapeEditProjectsAddProjectBasicInformationTemplate from '../../../templates/LandscapeEditProjectsAddProjectBasicInformationTemplate';
import { ProjectSupportState } from '../../pages/LandscapeProjectsAddProjectsRequestedSupportPage/LandscapeProjectsAddProjectsRequestedSupportPage';

interface LandscapeProjectsAddProjectsRequestedSupportTemplateProps {
  projectSupportState: ProjectSupportState;
  setProjectSupportState: React.Dispatch<React.SetStateAction<any>>;
  handleSubmit: () => void;
}

const LandscapeProjectsAddProjectsRequestedSupportTemplate: FC<
  LandscapeProjectsAddProjectsRequestedSupportTemplateProps
> = ({ projectSupportState, setProjectSupportState, handleSubmit }) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeEditProjectsAddProjectTemplate>
          <LandscapeEditProjectsAddProjectBasicInformationTemplate>
            <LandscapeProjectsAddRequestedSupportOrganism
              projectSupportState={projectSupportState}
              setProjectSupportState={setProjectSupportState}
              handleSubmit={handleSubmit}
            />
          </LandscapeEditProjectsAddProjectBasicInformationTemplate>
        </LandscapeEditProjectsAddProjectTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeProjectsAddProjectsRequestedSupportTemplate;
